import * as React from "react";
import classnames from "classnames";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import {
  FileExtendedDetails,
  FileState,
} from "../../commonTypes/fileupload.types";
import { Dialog } from "../Dialog/Dialog";
import { Icon } from "../Icon/icon";
/**
 * Represents a single file in [[Fileupload]] component.
 */
export interface IFileItemProps {
  index: number;
  onRemove(file: FileExtendedDetails, index?: number): void;
  fileMeta: FileExtendedDetails;
  removeText: string;
  removeFileText: string;
  removeFilePopupBody: string;
  abortText: string;
  closeText: string;
  okText: string;
  clientOnly?: boolean;
}

export interface IFileItemState {
  isModalOpen: boolean;
}
function buildClassName(status: FileState): string {
  return classnames("fileupload__filename", "file-extension-flaticon", {
    file__uploading: status === FileState.UPLOADING,
    file__settled: status === FileState.SETTLED,
    "fileupload__filename--invalid": status === FileState.INVALID,
  });
}

export class FileItem extends React.Component<IFileItemProps, IFileItemState> {
  static defaultProps = {} as IFileItemProps;

  constructor(props: IFileItemProps) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  closeDialog = () => {
    this.setState({ isModalOpen: false });
  };

  openDialog = () => {
    this.setState({ isModalOpen: true });
  };

  removeFile = () => {
    this.props.onRemove(this.props.fileMeta, this.props.index);
    this.setState({ isModalOpen: false });
  };

  render() {
    const {
      removeText,
      removeFileText,
      removeFilePopupBody,
      abortText,
      okText,
    } = this.props;
    return (
      <div className={buildClassName(this.props.fileMeta.status)}>
        {this.props.fileMeta.OriginalFilename}
        {this.props.fileMeta.FileId && (
          <>
            <button
              type="button"
              aria-label={`${removeFileText}: ${this.props.fileMeta.OriginalFilename}`}
              className="fileupload__remove"
              onClick={(e) => {
                e.preventDefault();
                this.openDialog();
              }}
            >
              <span className="fileupload__remove__icon">
                <span>{removeText}</span>{" "}
                <Icon iconType="fontawesome/trash-alt" />
              </span>
            </button>
            <Dialog
              isOpen={this.state.isModalOpen}
              onRequestClose={this.closeDialog}
            >
              <button onClick={this.closeDialog} className="close">
                <Icon
                  isAriaHidden={false}
                  ariaLabel={this.props.closeText}
                  iconType="ic_close_white_24px"
                />
              </button>
              <div className="header">
                <h2>{removeFileText}</h2>
              </div>
              <p>{removeFilePopupBody}</p>
              <div className="footer">
                <button
                  className="button button--white"
                  onClick={this.closeDialog}
                >
                  {abortText}
                </button>
                <button
                  className="button button--red"
                  onClick={this.removeFile}
                >
                  {okText}
                </button>
              </div>
            </Dialog>
          </>
        )}

        {!this.props.fileMeta.FileId && (
          <LoadingSpinner
            darkColor={true}
            cssClasses="fileupload__spinner fileupload__remove"
          />
        )}
      </div>
    );
  }
}
